<template>
  <v-navigation-drawer
    v-model="isOpen"
    right
    app
    width="450"
    class="preview-sidebar-drawer"
  >
    <div class="flex-column d-flex fill-height">
      <Preview
        v-if="previewReady"
        ref="previewComponent"
        :page="page || 'HOME'"
        :page-data="pageData"
        :packed-data="computedPackedData"
      />

      <div
        v-if="!previewReady"
        class="d-flex justify-center align-center fill-height"
      >
        <v-progress-circular indeterminate color="primary" />
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import {
  dispatchAppData,
  mapGettersAppData,
} from '@/shared/store/app-data.store'
import {
  commitPreview,
  dispatchPreview,
  mapStatePreview,
} from '@/shared/store/preview.store'
import { type PreviewGrabData } from '@/shared/types/applicationData.type'

import Preview from './Preview.vue'

export default defineComponent({
  name: 'PreviewSidebar',
  components: {
    Preview,
  },
  data: () => ({
    previewReady: false,
  }),
  computed: {
    ...mapStatePreview(['page', 'pageData', 'packedData']),
    ...mapGettersAppData(['getGrabData']),

    computedPackedData() {
      return this.packedData ?? this.getGrabData ?? undefined
    },

    isOpen: {
      get(): boolean {
        return this.$store.state.preview.isOpen
      },
      set(value: boolean) {
        commitPreview('setOpen', value)
      },
    },
  },
  watch: {
    computedPackedData: {
      immediate: true,
      handler(data: PreviewGrabData | null | undefined) {
        if (data && !this.previewReady) {
          this.previewReady = true
        }
      },
    },
  },
  methods: {
    async closePreview() {
      await dispatchPreview('closePreview')
    },
  },
  async mounted() {
    if (!this.packedData) {
      await dispatchAppData('loadCurrentData', { filterOnlyVisible: true })
    }
  },
})
</script>

<style lang="scss" scoped>
.preview-sidebar-drawer {
  background-image: url('@/assets/bg_pattern.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>
